import { Map } from 'component/Map';
import React from 'react';
import { useBufferZone } from 'hooks/useBufferZone';
import { useHAReports } from 'hooks/useHAReports';
import { HASwitchers } from 'component/HASwitchers';

export const MarkingMap = ({ formData, map, setMap }) => {
  useBufferZone(map);
  const haReportsMarkingMap = useHAReports(map);

  return (
    <div style={{ position: 'relative' }}>
      <HASwitchers
        {...haReportsMarkingMap}
        googleWms={true}
        style={{
          position: 'absolute',
          top: '66px',
          zIndex: 1,
          background: 'rgba(255, 255, 255, 0.8)',
          borderRadius: '4px',
          padding: '0px 15px 7px 10px',
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          left: '0px',
          borderRadius: '0 0 8px',
          boxShadow: '0px 20px 25px 0px rgba(76, 103, 100, 0.1)',
        }}
      />
      <Map
        map={map}
        formData={formData}
        setMap={setMap}
        haReportsPolygons={haReportsMarkingMap?.haReportsPolygons}
        // azureLayerEnabled={haReportsMarkingMap?.azureLayerEnabled}
        // setAzureLayerEnabled={haReportsMarkingMap?.setAzureLayerEnabled}
        googleWms
      />
    </div>
  );
};
